// extracted by mini-css-extract-plugin
export default {"app":"App_app__FHIy8","menu":"App_menu__Zb5A+","active":"App_active__t86Iz","select":"App_select__gosU9"};